import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DM_PARAMS_DEFAULT, EPSILON_DPID, EPSILON_TENANT_ID } from '../../../data/component-templates-config';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-engagement-tracker',
	templateUrl: './engagement-tracker.component.html',
	styleUrls: ['./engagement-tracker.component.scss']
})
export class EngagementTrackerComponent implements OnInit {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('engagementTracker', { static: true }) engagementTracker: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	defaultParams = {
		dpid: DM_PARAMS_DEFAULT.dpid,
		uid: DM_PARAMS_DEFAULT.uid
	};

	constructor(private auth: AuthService) {}

	ngOnInit() {
		const tenantId = this.auth.getUser().tenant_id;
		this.defaultParams.dpid = tenantId === EPSILON_TENANT_ID ? EPSILON_DPID : this.defaultParams.dpid;
		this.componentData.config.trackParams = this.componentData.config.trackParams
			? this.componentData.config.trackParams
			: this.defaultParams;
	}

	paramChange() {
		this.componentData.config.dm_params.dpid = this.componentData.config.trackParams.dpid;
		this.componentData.config.dm_params.uid = this.componentData.config.trackParams.uid;
	}
}
